import React from "react";

import "css/CartItem.css";

import { Row, Column } from "react-foundation";

import "css/SummaryItem.css";

import Date from "./Date";
import DimensionSummary from "./DimensionSummary";
import Image from "components/Image";

const DoorCompositeCartItem = ({ Product }) => {
    return (
        <table>
            <tbody>
                <tr>
                    <td className="product-label">Type</td>
                    <td className="product-field">{Product.Type.Name}</td>
                </tr>
                <tr>
                    <td className="product-label">Colour</td>
                    <td className="product-field">
                        {Product.Colour.Exterior.Name} / {Product.Colour.Interior.Name}
                    </td>
                </tr>
                <tr>
                    <td className="product-label">Lock</td>
                    <td className="product-field">Winkhaus Secure</td>
                </tr>
                <tr>
                    <td className="product-label">Handle</td>
                    <td className="product-field">{Product.Handle.Name}</td>
                </tr>
                <tr>
                    <td className="product-label">Letterbox</td>
                    <td className="product-field">{Product.HasLetterbox ? Product.Letterbox.Name : "-"}</td>
                </tr>
                <tr>
                    <td className="product-label">Knocker</td>
                    <td className="product-field">{Product.HasKnocker ? Product.Knocker.Name : "-"}</td>
                </tr>
                <tr>
                    <td className="product-label">Frame</td>
                    <td className="product-field">{Product.Frame.Name}</td>
                </tr>
                <tr>
                    <td className="product-label">Style</td>
                    <td className="product-field">{Product.Glass.Name}</td>
                </tr>
            </tbody>
        </table>
    );
};
const DoorUPVCCartItem = ({ Product }) => {
    const isPatioOrBifold = /patio/i.test(Product.Type.Name) || /bi-?fold/i.test(Product.Type.Name);    
    const unit = Product.Size.Unit;
    return (
        <table>
            <tbody>
                <tr>
                    <td className="product-label">Style</td>
                    <td className="product-field">{Product.Type.Name}</td>
                </tr>
                <tr>
                    <td className="product-label">Colour</td>
                    <td className="product-field">
                        {Product.Colour.Name}
                        {Product.Colour.WhiteInterior ? "/ White" : ""}
                    </td>
                </tr>
                <tr>
                    <td className="product-label">Lock</td>
                    <td className="product-field">{"Yale"}</td>
                </tr>
                <tr>
                    <td className="product-label">Handle</td>
                    <td className="product-field">{Product.Handle.Name}</td>
                </tr>
                <tr>
                    <td className="product-label">Letterbox</td>
                    <td className="product-field">{Product.HasLetterbox ? Product.Letterbox.Name : "-"}</td>
                </tr>
                {isPatioOrBifold &&
                <tr>
                    <td className="product-label">Dimensions</td>
                    <td className="product-field">
                        <DimensionSummary width={Product.Size.Width} height={Product.Size.Height} unit={unit}/>
                    </td>
                </tr>
                }
            </tbody>
        </table>
    );
};
const WindowCartItem = ({ Product }) => {
    return (
        <table>
            <tbody>
                <tr>
                    <td className="product-label">Style</td>
                    <td className="product-field">{Product.Style.Name}</td>
                </tr>
                <tr>
                    <td className="product-label">Size</td>
                    <td className="product-field capitalised">
                        {
                            Product.Size.Display.Width && Product.Size.Display.Height && Product.Size.Display.Unit ? 
                                <DimensionSummary width={Product.Size.Display.Width} height={Product.Size.Display.Height} unit={Product.Size.Display.Unit}/>
                                :
                                Product.Size.Display
                        }
                    </td>
                </tr>
                <tr>
                    <td className="product-label">Layout</td>
                    <td className="product-field">{Product.Design.Name}</td>
                </tr>
                <tr>
                    <td className="product-label">Colour</td>
                    <td className="product-field">{Product.Colour.Name}</td>
                </tr>
                <tr>
                    <td className="product-label">Handles</td>
                    <td className="product-field">{Product.HasHandle ? Product.Handle.Name : "-"}</td>
                </tr>
                <tr>
                    <td className="product-label">Lock</td>
                    <td className="product-field">{Product.Lock.Name}</td>
                </tr>
            </tbody>
        </table>
    );
};

const ConservatoryCartItem = ({ Product }) => {
    return (
        <table>
            <tbody>
                <tr>
                    <td className="product-label">Style</td>
                    <td className="product-field">{Product.Style.Name}</td>
                </tr>
                <tr>
                    <td className="product-label">Size</td>
                    <td className="product-field">
                        <DimensionSummary width={Product.Size.UserSelected.Width} height={Product.Size.UserSelected.Height} unit={Product.Size.UserSelected.Unit}/>
                    </td>
                </tr>
                <tr>
                    <td className="product-label">Roof</td>
                    <td className="product-field">{Product.Design.Name}</td>
                </tr>
                <tr>
                    <td className="product-label">Colour</td>
                    <td className="product-field">{Product.Colour.Name}</td>
                </tr>
            </tbody>
        </table>
    );
};


const CartItem = ({ Product }) => {
    let isWindow = Product.ItemType.Name === "Window";
    let isDoor = Product.ItemType.Name === "Door";
    let isConservatory = Product.ItemType.Name === "Conservatory";
    let isUPVC = (Product.Type && Product.Type.IsComposite === false) || false;
    let isComposite = (Product.Type && Product.Type.IsComposite === true) || false;

    return (
        <div className="CartItem">
            <Row>
                <Column small={8}>
                    <span className="product-name">{Product.Name}</span>
                    <br />
                    <span className="created-date">
                        Created: <Date value={Product.CreatedDate} format="0D-0M-YYYY" />
                    </span>
                </Column>
                <Column small={4}>
                    {isComposite && <img src={Product.FlattenedImageSrc} alt="" />}
                    {((isWindow || !isComposite) && !isConservatory) && <div style={{height:100}} dangerouslySetInnerHTML={{ __html: Product.SvgImage }} />}
                    {isConservatory && <div><Image src={Product.Style.Image} alt=""/></div>}
                </Column>
            </Row>
            <Row>
                <Column className="product-details" small={12}>
                    {isWindow && <WindowCartItem Product={Product} />}
                    {isDoor && isUPVC && <DoorUPVCCartItem Product={Product} />}
                    {isDoor && isComposite && <DoorCompositeCartItem Product={Product} />}
                    {isConservatory && <ConservatoryCartItem Product={Product} />}
                </Column>
            </Row>
        </div>
    );
};

export default CartItem;



// WEBPACK FOOTER //
// ./src/components/CartItem.js